export const StacksLinks = (companyId = null, username = null) => {
  return [
    {
      id: 1,
      name: 'stacks_company',
      url: `/superstack/stacks/companies/${companyId}/`,
    },
    {
      id: 2,
      name: 'stacks_recommend_jobs',
      url: `/superstack/stacks/v1/recs/${username}/jobs/`,
    },
  ];
};
